<template lang="pug">
AppInput(
  :value="formattedDuration"
  placeholder="0:00"
  @up="onUp"
  @down="onDown"
  @change="onChange"
)
</template>

<script>
import { formatDuration } from '~/utils/time_utils';

export default {
  name: 'WorkBreakPolicyDurationInput',
  props: {
    value: {
      required: true,
    },
  },
  data() {
    return {
      currentValue: null,
    };
  },
  computed: {
    formattedDuration() {
      const formattedDuration = formatDuration(this.currentValue, { showSeconds: 'never' });

      return formattedDuration || this.currentValue;
    },
  },
  watch: {
    value(val) {
      this.currentValue = val;
    },
  },
  created() {
    this.currentValue = this.value;
  },
  methods: {
    onUp() {
      this.$emit('input', this.value.clone().add(1, 'minutes'));
    },
    onDown() {
      this.$emit('input', this.value.clone().subtract(1, 'minutes'));
    },
    onChange(val) {
      const parsedDuration = TimeInput.parse_duration(val);

      if (parsedDuration) {
        this.currentValue = parsedDuration.asSeconds();
        this.$emit('input', this.currentValue);
      } else {
        this.currentValue = val;
        this.$emit('input', this.currentValue);
      }
    },
  },
};
</script>
